import React from "react";
import { Grid } from "@material-ui/core";
import { DPPayrollAnomalyFile } from "Shared/types/PayrollAnomaly";
import { FileDetailsTable } from "./FileDetailsTable/FileDetailsTable";
import { NetPayStatsTable } from "./NetPayStatsTable/NetPayStatsTable";
import { FileSummaryTable } from "./FileSummaryTable/FileSummaryTable";
import useStyles from "./styles";

export interface PayrollAnomalyDetailsProps {
  fileDetails: DPPayrollAnomalyFile;
}

export const PayrollAnomalyDetails = ({ fileDetails }: PayrollAnomalyDetailsProps) => {
  const classes = useStyles();
  const payrollFileStats = fileDetails?.anomalyReport?.stats;

  return (
    <Grid container spacing={10} direction="row" className={classes.tablesWrapper}>
      <Grid item container xs={6}>
        <Grid item xs={12} className={classes.fileDetailsTable}>
          <FileDetailsTable
            filename={fileDetails?.originalFilename || ""}
            createdAt={fileDetails?.createdAt || ""}
          />
        </Grid>
        <Grid item xs={12}>
          <NetPayStatsTable {...payrollFileStats} />
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <FileSummaryTable {...payrollFileStats} />
      </Grid>
    </Grid>
  );
};
